import React, { useState, useEffect, useRef } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Navbar.css';

// Smooth scroll to section
const scrollToSection = (id: string) => {
  const element = document.getElementById(id);
  if (element) {
    element.scrollIntoView({ behavior: 'smooth' });
  }
};

const Navbar: React.FC = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const navRef = useRef<HTMLElement>(null);
  const location = useLocation();

  const isActive = (path: string) => location.pathname === path;

  // Handle scroll effect
  useEffect(() => {
    const handleScroll = () => {
      const isScrolled = window.scrollY > 10;
      if (isScrolled !== scrolled) {
        setScrolled(isScrolled);
      }
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, [scrolled]);

  const toggleMenu = () => setIsOpen(!isOpen);

  const closeMenu = () => {
    setIsOpen(false);
    document.body.style.overflow = 'unset';
  };

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }

    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);

  // Close menu when route changes
  useEffect(() => {
    closeMenu();
  }, [location]);

  return (
    <nav 
      ref={navRef}
      className={`navbar ${isOpen ? 'mobile-open' : ''} ${scrolled ? 'scrolled' : ''}`}
    >
      <div className="container nav-container">
        <Link to="/" className="nav-logo" onClick={closeMenu}>
          <div className="logo-placeholder">
            <img src="/images/logo.png" alt="Dream Advance Logo" className="logo-image" />
          </div>
        </Link>
        
        <div className="nav-controls">
          <div 
            className={`hamburger ${isOpen ? 'active' : ''}`} 
            onClick={toggleMenu}
            aria-label="Toggle navigation"
          >
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>

        <div 
          className={`nav-overlay ${isOpen ? 'active' : ''}`} 
          onClick={closeMenu}
        />
        <ul className={`nav-menu ${isOpen ? 'active' : ''}`}>
          <li className="nav-close" onClick={closeMenu}>
            <span>×</span>
          </li>
          <li className="nav-item">
            <Link 
              to="/" 
              className={`nav-link ${isActive('/') ? 'active' : ''}`}
              onClick={closeMenu}
            >
              Home
            </Link>
          </li>
          <li className="nav-item">
            <Link 
              to="/tracks" 
              className={`nav-link ${isActive('/tracks') ? 'active' : ''}`}
              onClick={closeMenu}
            >
              Tracks
            </Link>
          </li>
          <li className="nav-item">
            <Link 
              to="/gallery" 
              className={`nav-link ${isActive('/gallery') ? 'active' : ''}`}
              onClick={closeMenu}
            >
              Gallery
            </Link>
          </li>
          <li className="nav-item">
            <Link 
              to="/pricing" 
              className={`nav-link ${isActive('/pricing') ? 'active' : ''}`}
              onClick={closeMenu}
            >
              Pricing
            </Link>
          </li>
          <li className="nav-item mobile-only">
            <Link 
              to="/register" 
              className="nav-link btn-style register-mobile"
              onClick={closeMenu}
            >
              Register Now
            </Link>
          </li>
        </ul>

        <div className="nav-buttons mobile-hidden">
          <Link to="/register" className="btn btn-primary register-btn">
            Register Now
          </Link>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
